import { Mail, Reply } from 'lucide-react';

import cn from '@/lib/utils/cn';

type Props = {
  className?: string;
};

export default function MailReplyIcon({ className }: Props) {
  return (
    <div
      className={cn(
        'relative flex h-5 w-5 items-center justify-center',
        className,
      )}
    >
      <Mail className="text-primary-500 h-4 w-4" />
      <div className="bg-primary-50 dark:bg-primary-800 absolute -right-px -bottom-px rounded-full">
        <Reply className="text-primary-500 h-3 w-3" />
      </div>
    </div>
  );
}
